import React, { useEffect } from 'react'
import Media from '../components/MediaPage/Media'

const MediaPage = () => {

  useEffect(() => {
          window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Media />  
    </div>
  )
}

export default MediaPage
